import { Head, Link } from "@inertiajs/react"
import type { Listing } from "@/types"
import DashboardLayout from "@/components/dashboard/layout"
import ListingForm from "@/components/dashboard/listing-form"

export default function EditListing({ listing }: { listing: Listing }) {
  return (
    <DashboardLayout>
      <Head title={`Edit ${listing.address} | QuiteRight`} />

      <div className="mb-8">
        <Link
          href={`/dashboard/listings/${listing.slug}`}
          className="mb-4 inline-flex items-center gap-1 text-sm text-warm-grey hover:text-charcoal"
        >
          <svg className="size-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
          Back to listing
        </Link>
        <h1 className="font-display text-2xl font-semibold tracking-tight text-charcoal">
          Edit listing
        </h1>
        <p className="mt-1 text-warm-grey">{listing.address}</p>
      </div>

      <ListingForm listing={listing} action="update" />
    </DashboardLayout>
  )
}
